import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { usePitchContext } from "../../context/pitchContext";
import AuthLogo from "../assets/iconProfilePicture.png";
import Nav from "./Nav";
import Comment from "./Comment";
import "./Blog.css";
import axios from "axios";
import Alert from "../Alert/Alert";
import Footer from "../Footer/Footer";

function Blog(props) {

  const [singlePitch, setSinglePitch] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    const url = "https://tbc-backend.up.railway.app/pitch/getOne/"
    axios.get(url + id).then(response => {
      setSinglePitch(response.data)
    }).catch(error => { console.log(error); })
  }, [id]);

  document.title = singlePitch.pitchTitle;

  return (
    <>
      <section className="bg-black homeBg fs-5">
        <Nav handleLogout={props.handleLogout} />
        <Alert mT='85px' mR='40px' />

        <div className=" ">
          <div className="container bg-black px-4 px-md-0">
            <div
              style={{ maxWidth: 700, top: "-80px" }}
              className="mx-auto text-secondary bg-black pt-5"
            >
              <div class="badge text-bg-warning mt-5 ">
                <p className="">
                  {singlePitch.pitchDate} | {singlePitch.pitchTime}
                </p>
              </div>

              <div className="mt-5 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <img src={AuthLogo} style={{ width: 50 }} alt="img" />
                  <small className="ml-2">
                    <p href="#" className="text-primary d-block">
                      {singlePitch.pitchAuthor}
                    </p>
                    <span>
                      {singlePitch.pitchAuthorCurrentField} -{" "}
                      {singlePitch.pitchAuthorNiche}
                    </span>
                  </small>
                </div>
              </div>

              <h6 className=" text-warning mt-5 fs-3">
                {" "}
                {singlePitch.pitchType}{" "}
              </h6>
              <h1
                className="my-2 bg-black text-white mt-2 fs-2"
                style={{ lineHeight: 2 }}
              >
                {singlePitch.pitchTitle}
              </h1>
            </div>
            <div
              style={{ maxWidth: 700, top: "80px" }}
              className="mx-auto text-white fs-5"
            >
              <p
                className="my-4 pb-5 bg-black "
                style={{
                  lineHeight: 2,
                  textAlign: "justify",
                  whiteSpace: "pre-wrap",
                }}
              >
                {singlePitch.pitchDescp}
              </p>
            </div>
          </div>
          <div className="container w-50 pb-5">
            <hr className="new2" />
            <hr className="new2 mt-1" />
          </div>
        </div>
        <Comment email={props.email} />
      </section>
      <Footer />
    </>
  );
}

export default Blog;
